import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.date.now.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.splice.js";

/* eslint prefer-rest-params:0 no-restricted-syntax:0 */
var WeishiBridge = {};
var ua = navigator.userAgent; // 借用方法的常量

var SLICE = Array.prototype.slice;
var TOSTRING = Object.prototype.toString;
var REGEXP_IOS = /\b(iPad|iPhone|iPod)\b.*? OS ([\d_]+)/; // fix by jdochen 2015/09/15
// 个别低端机型UA：Android/2.3.5

var REGEXP_ANDROID = /\bAndroid([^;]+)/; // 小米的奇葩系统没有android内核的这个数字版本号啊s
// 内部使用的变量

var aCallbacks = WeishiBridge.__aCallbacks || {}; // 调用回调

var aReports = WeishiBridge.__aReports || {}; // API 调用的名字跟回调序号的映射

var aSupports = WeishiBridge.__aSupports || {}; // 保存 API 的版本支持信息

var aFunctions = WeishiBridge.__aFunctions || {}; // 保存 API 的名字和生成的方法映射

var UUIDSeed = 1;
/*
  * 扩展 obj 对象
  * @param  {[type]} obj [description]
  * @param  {[type]} ext [description]
  * @return {[type]}     [description]
  */

function extend(obj, ext, overwrite) {
  var i;

  for (i in ext) {
    // eslint-disable-next-line
    if (ext.hasOwnProperty(i) && !(i in obj) || overwrite) {
      obj[i] = ext[i];
    }
  }

  return obj;
} // 生成一些列的类型判断方法


extend(WeishiBridge, function () {
  var exp = {};
  var types = 'Object,Function,String,Number,Boolean,Date,Undefined,Null';
  types.split(',').forEach(function (t) {
    exp["is".concat(t)] = function (obj) {
      return TOSTRING.call(obj) === "[object ".concat(t, "]");
    };
  });
  return exp;
}());
/**
 * @attribute core.iOS
 * @desc 如果在 iOS 中，值为 true，否则为 false
 * @support iOS 4.2
 * @support android 4.2
 */

WeishiBridge.iOS = REGEXP_IOS.test(ua);
/**
 * @attribute core.android
 * @desc 如果在 android 中，值为 true，否则为 false
 * @support iOS 4.2
 * @support android 4.2
 */

WeishiBridge.android = REGEXP_ANDROID.test(ua);

if (WeishiBridge.iOS && WeishiBridge.android) {
  /*
      * 同时是 iOS 和 android 是不可能的, 但是有些国产神机很恶心,
      * 明明是 android, ua 上还加上个 iPhone 5s...
      * 这里要 fix 掉
      */
  WeishiBridge.iOS = false;
}
/**
 * @attribute core.version
 * @desc mqqapi自身的版本号
 * @support iOS 4.2
 * @support android 4.2
 */


WeishiBridge.version = '20170222001';
/**
 * @attribute core.QQVersion
 * @desc 如果在 手机 QQ中，值为手机QQ的版本号，如：4.6.2，否则为 0
 * @support iOS 4.2
 * @support android 4.2
 */

WeishiBridge.QQVersion = '0';
WeishiBridge.clientVersion = '0';
WeishiBridge.ERROR_NO_SUCH_METHOD = 'no such method';
WeishiBridge.ERROR_PERMISSION_DENIED = 'permission denied';
/**
 * @function core.callback
 * @desc 用于生成回调名字，跟着 invoke 的参数传给客户端，客户端执行回调时，根据该回调名字找到相应的回调处理函数并执行
 * @param {Function} handler 接口的回调处理函数
 * @param {Boolean} [deleteOnExec] 若为 true 则执行完该回调之后删除之，用于防止同一个回调被多次执行（某些情况下有用）
 * @param {Boolean} [execOnNewThread] 若为 true 则在另一个线程执行回调，iOS 中，以下两种场景须指定该参数为 true
 * @default for execOnNewThread true
 *
 * @important 如果在 UI 相关接口的回调中调用 alert 等 UI 接口，会导致 WebView 假死，只能关进程处理
 * @important 如果在接口 A 的回调中继续调用接口 B，接口 B 的调用可能会无效亦或者返回结果不正确
 *
 * @example
 * var callbackName = mqq.callback(function(type, index){
 *     console.log("type: " + type + ", index: " + index);
 * });
 * //弹出 ActionSheet
 * mqq.invoke("ui", "showActionSheet", {
 *     "title" : "title",
 *     "items" : ["item1", "item2"],
 *     "cancel" : "cancel",
 *     "close" : "close",
 *     "onclick": callbackName
 * }
 *
 * @support iOS 4.2
 * @support android 4.2
 */

function createCallbackName(callback, deleteOnExec, execOnNewThread) {
  callback = WeishiBridge.isFunction(callback) ? callback : window[callback];

  if (!callback) {
    return;
  } // // 默认执行一遍后就删掉
  // if (WeishiBridge.isUndefined(deleteOnExec)) {
  //     deleteOnExec = true;
  // }


  var sn = storeCallback(callback);
  var name = "__MQQ_CALLBACK_".concat(sn); // alert(name)

  window[name] = function () {
    var argus = SLICE.call(arguments);
    fireCallback(sn, argus, deleteOnExec, execOnNewThread);
  };

  return name;
}

function storeCallback(callback) {
  var sn = "".concat(UUIDSeed);
  UUIDSeed += 1;

  if (callback) {
    /* window[sn] = */
    aCallbacks[sn] = callback;
  }

  return sn;
}
/*
  * 从 obj 中找出错误码
  * @param  {Object} obj
  */


function getResultCode(obj) {
  var retCode;
  var j;
  var n;
  var keys = ['retCode', 'retcode', 'resultCode', 'ret', 'code', 'r'];

  for (j = 0, n = keys.length; j < n; j++) {
    if (keys[j] in obj) {
      retCode = obj[keys[j]];
      break;
    }
  }

  return retCode;
}
/*
  * 所有回调的最终被执行的入口函数
  */


function fireCallback(sn, argus, deleteOnExec, execOnNewThread) {
  var callback = WeishiBridge.isFunction(sn) ? sn : aCallbacks[sn] || window[sn];
  var endTime = Date.now();
  var retCode;
  var obj;
  argus = argus || [];
  var result = argus[0]; // 默认都在新线程执行

  if (WeishiBridge.isUndefined(execOnNewThread)) {
    execOnNewThread = true;
  } // 统一回调格式 { code: 0, msg: "", data: {} }


  if (WeishiBridge.isObject(result)) {
    if (!('data' in result)) {
      result.data = extend({}, result);
    }

    if (!('code' in result)) {
      result.code = getResultCode(result) || 0;
    }

    result.msg = result.msg || '';
  }

  if (WeishiBridge.isFunction(callback)) {
    if (execOnNewThread) {
      setTimeout(function () {
        // alert(callback)
        // eslint-disable-next-line
        callback.apply(null, argus);
      }, 0);
    } else {
      // eslint-disable-next-line
      callback.apply(null, argus);
    }
  } else {
    console.log("mqqapi: not found such callback: ".concat(sn, " or the callback: ").concat(sn, " had some errors! API: ").concat(sn.name));
  }

  if (deleteOnExec) {
    delete aCallbacks[sn];
    delete window["__MQQ_CALLBACK_".concat(sn)];
  } // 上报 API 调用返回
  // alert(sn)


  if (aReports[sn]) {
    obj = aReports[sn];
    delete aReports[sn];

    if (Number(sn)) {
      delete aReports["__MQQ_CALLBACK_".concat(sn)];
    }

    if (result) {
      // 只取第一个参数来判断
      if (result.code !== undefined) {
        retCode = result.code;
      } else if (/^-?\d+$/.test(String(result))) {
        // 第一个参数是个整数, 认为是返回码
        retCode = result;
      }
    } // 发上报请求


    console.log("".concat(obj.uri, "#callback"), retCode, endTime - obj.startTime);
  }
}
/*
  * android / iOS 5.0 开始, client回调 js, 都通过这个入口函数处理
  */


function execGlobalCallback(sn) {
  var argus = SLICE.call(arguments, 1);

  if (WeishiBridge.android && argus && argus.length) {
    // 对 android 的回调结果进行兼容
    // android 的旧接口返回会包装个 {r:0,result:123}, 要提取出来
    argus.forEach(function (data, i) {
      if (WeishiBridge.isObject(data) && 'r' in data && 'result' in data) {
        argus[i] = data.result;
      }
    });
  }

  fireCallback(sn, argus);
}
/*
  * 使用 iframe 发起伪协议请求给客户端
  */


function openURL(url, ns, method, sn) {
  var iframe = document.createElement('iframe');
  iframe.style.cssText = 'display:none;width:0px;height:0px;';

  function failCallback() {
    /*
          正常情况下是不会回调到这里的, 只有客户端没有捕获这个 url 请求,
          浏览器才会发起 iframe 的加载, 但这个 url 实际上是不存在的,
          会触发 404 页面的 onload 事件
          */
    execGlobalCallback(sn, {
      r: -201,
      result: 'error'
    });
  }

  if (WeishiBridge.iOS) {
    /*
          ios 必须先赋值, 然后 append, 否者连续的 api调用会间隔着失败
          也就是 api1(); api2(); api3(); api4(); 的连续调用,
          只有 api1 和 api3 会真正调用到客户端
          */
    iframe.onload = failCallback;
    iframe.src = url;
  }

  (document.body || document.documentElement).appendChild(iframe);
  /*
      android 这里必须先添加到页面, 然后再绑定 onload 和设置 src
      1. 先设置 src 再 append 到页面, 会导致在接口回调(callback)中嵌套调用 api会失败,
      iframe会直接当成普通url来解析
      2. 先设置onload 在 append , 会导致 iframe 先触发一次 about:blank 的 onload 事件
       */

  if (WeishiBridge.android) {
    // android 必须先append 然后赋值
    iframe.onload = failCallback;
    iframe.src = url;
  } // iOS 可以同步获取返回值, 因为 iframe 的url 被客户端捕获之后, 会挂起 js 进程


  var returnValue = WeishiBridge.__RETURN_VALUE;
  WeishiBridge.__RETURN_VALUE = undefined; // android 捕获了iframe的url之后, 也是中断 js 进程的, 所以这里可以用个 setTimeout 0 来删除 iframe

  setTimeout(function () {
    iframe && iframe.parentNode && iframe.parentNode.removeChild(iframe);
  }, 500);
  return returnValue;
}
/**
 * @function core.invoke
 * @desc mqq 核心方法，用于调用客户端接口。invoke 封装了两个系统（android、ios）的不同，同时对不同版本进行了兼容。
 * @param {String} namespace 命名空间，每个客户端接口都属于一个命名空间，若不清楚，请咨询对应的客户端开发
 * @param {String} method 接口名字
 * @param {Object} [params] API 调用的参数
 * @param {Function} [callback] API 调用的回调
 * @important 因历史版本的客户实现问题，同一个接口在 android 和 iOS 命名空间和方法名都不一致，同时接口实现的也可能有些许差异，
 * 因此尽量使用下面封装好的方法，如：mqq.ui.openUrl。直接调用 invoke 的情况只建议在 android 和 iOS 的实现命名空间和方法以及参数格式都完全一致时使用。
 * @example
 * // 调用普通接口
 * // ios, android
 * mqq.invoke("ns", "method");
 *
 * @example
 * // 调用需要传参数的接口
 * mqq.invoke("ns", "method", {foo: 'bar'});
 *
 * @example
 * // 调用需要传参数且有回调结果的接口
 * mqq.invoke("ns", "method", {foo: 'bar'}, function(data){
 *     console.log(data);
 * });
 *
 *
 * @support iOS 4.2
 * @support android 4.2
 * @support for params iOS 4.5
 * @support for params android 4.7
 */


function invokeClientMethod(ns, method, params, callback) {
  // 限制iframe里面调用
  if (!ns || !method || window !== window.top) {
    return null;
  }

  var url;
  var sn;
  var constCBStr = '__MQQ_CALLBACK_'; // sn 是回调函数的序列号

  var argus = SLICE.call(arguments, 2);
  callback = argus.length && argus[argus.length - 1];

  if (WeishiBridge.isFunction(callback)) {
    // args最后一个参数是function, 说明存着callback
    argus.pop();
  } else if (WeishiBridge.isUndefined(callback)) {
    // callback 是undefined的情况, 可能是 api 定义了callback, 但是用户没传 callback, 这时候要把这个 undefined的参数删掉
    argus.pop();
  } else {
    callback = null;
  } // 微视一定要params，从这里面取callbackName


  if (argus.length <= 0) {
    argus.push({});
  } // eslint-disable-next-line


  params = argus[0]; // 一般的接口调用只会有一个参数，这里也只对第一个参数做些特殊处理

  var lastParam = argus[argus.length - 1]; // 调用mqq.callback的方式有如下几种
  // 1.第三个参数直接传mqq.callback(callback)的返回值，为字符串
  // 2.第三个参数传一个对象，对象的callback字段传mqq.callback(callback)的返回值
  // 3.在最后一个参数(不一定是第四个)，直接传入mqq.callback(callback)的返回值

  if (typeof params === 'string' && params.indexOf(constCBStr) === 0) {
    sn = parseInt(argus[0].replace(constCBStr, ''), 10);
  } else if (WeishiBridge.isObject(params) && params.callback && params.callback.indexOf(constCBStr) === 0) {
    sn = parseInt(params.callback.replace(constCBStr, ''), 10);
  } else if (typeof lastParam === 'string' && lastParam.indexOf(constCBStr) === 0) {
    sn = parseInt(lastParam.replace(constCBStr, ''), 10);
  } else {
    // 原始逻辑
    // 统一生成回调序列号, callback 为空也会返回 sn
    sn = storeCallback(callback);
  } // 如果最后一个参数传了 function, 且 params 里面没有 'callback' 属性的, 把function赋值给params
  // 兼容之后, 任何参数调用都可以直接 mqq.invoke('ns', 'method', params, callback) 了
  // az @ 2015/4/17


  if (callback && WeishiBridge.isObject(params) && !params.callback) {
    window["__MQQ_CALLBACK_AUTO_".concat(sn)] = callback;
    params.callback = "__MQQ_CALLBACK_AUTO_".concat(sn);
  }
  /*
      android 4.7 以上的支持 ios的协议, 但是客户端的旧接口需要迁移, 4.7赶不上, 需要等到 4.7.2
      jsbridge://ns/method?p=test&p2=xxx&p3=yyy#123
      */


  url = "jsbridge://".concat(encodeURIComponent(ns), "/").concat(encodeURIComponent(method));
  argus.forEach(function (a, i) {
    if (WeishiBridge.isObject(a)) {
      a = JSON.stringify(a);
    }

    if (i === 0) {
      url += '?p=';
    } else {
      url += "&p".concat(i, "=");
    }

    url += encodeURIComponent(String(a));
  }); // 加上回调序列号

  if (method !== 'pbReport') {
    /*
     * pbReport 这个接口不能加回调序号, 这个接口本来就不支持回调
     * 但是 android 的 jsbridge 即使接口没有回调结果, 也会调用一次 js 表示这次接口调用到达了客户端
     * 同时, 由于 android 一执行 loadUrl('javascript:xxx') 就会导致软键盘收起
     * 所以上报的时候经常会引发这个问题, 这里就直接不加回调序号了
     */
    url += "#".concat(sn);
  }

  var result = openURL(url, ns, method);

  if (WeishiBridge.iOS && result !== undefined && result.result !== undefined) {
    // FIXME 这里可能会导致回调两次, 但是 iOS 4.7.2以前的接口是依靠这里实现异步回调, 因此要验证下
    if (callback) {
      fireCallback(sn, [result.result]);
    } else {
      return result.result;
    }
  }

  return null;
} // function invoke (ns, method, argus, callback) {


function invoke() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var ns = args[0],
      method = args[1];
  var func = aFunctions["".concat(ns, ".").concat(method)];

  if (WeishiBridge.isFunction(func)) {
    // 调用参数要去掉ns 和 method
    return func.apply(this, SLICE.call(args, 2));
  }

  return invokeClientMethod.apply(this, SLICE.call(args));
} // ////////////////////////////////// end util /////////////////////////////////////////////////
// ////////////////////////////////// event /////////////////////////////////////////////////

/**
 * @function core.addEventListener
 * @desc 监听客户端事件，该事件可能来自客户端业务逻辑，也可能是其他 WebView 使用 dispatchEvent 抛出的事件
 * @param {String} eventName 事件名字
 * @param {Function} handler 事件的回调处理函数
 * @param {Object} handler.data 该事件传递的数据
 * @param {Object} handler.source 事件来源
 * @param {string} handler.source.url 抛出该事件的页面地址
 * @example
 * mqq.addEventListener("hiEvent", function(data, source){
 *     console.log("someone says hi", data, source);
 * })
 *
 * @support iOS 5.0
 * @support android 5.0
 */


function addEventListener(eventName, handler) {
  if (eventName === 'qbrowserVisibilityChange') {
    // 兼容旧的客户端事件
    document.addEventListener(eventName, handler, false);
    return true;
  }

  var evtKey = "evt-".concat(eventName);
  (aCallbacks[evtKey] = aCallbacks[evtKey] || []).push(handler);
  return true;
}
/**
 * @function core.removeEventListener
 * @desc 移除客户端事件的监听器
 * @param {String} eventName 事件名字
 * @param {Function} [handler] 事件的回调处理函数，不指定 handler 则删除所有该事件的监听器
 *
 * @support iOS 5.0
 * @support android 5.0
 */


function removeEventListener(eventName, handler) {
  var evtKey = "evt-".concat(eventName);
  var handlers = aCallbacks[evtKey];
  var flag = false;
  var i;

  if (!handlers) {
    return false;
  }

  if (!handler) {
    delete aCallbacks[evtKey];
    return true;
  }

  for (i = handlers.length - 1; i >= 0; i--) {
    if (handler === handlers[i]) {
      handlers.splice(i, 1);
      flag = true;
    }
  }

  return flag;
} // 这个方法时客户端回调页面使用的, 当客户端要触发事件给页面时, 会调用这个方法


function execEventCallback(eventName
/* , data, source */
) {
  var evtKey = "evt-".concat(eventName);
  var handlers = aCallbacks[evtKey];
  var argus = SLICE.call(arguments, 1);

  if (handlers) {
    handlers.forEach(function (handler) {
      fireCallback(handler, argus, false);
    });
  }
}
/**
 * @function core.dispatchEvent
 * @desc 抛出一个事件给客户端或者其他 WebView，可以用于 WebView 间通信，或者通知客户端对特殊事件做处理（客户端需要做相应开发）
 * @param {String} eventName 事件名字
 * @param {Object} data 事件传递参数
 * @param {Object} options 事件参数
 * @param {Boolean} options.echo 当前webview是否能收到这个事件，默认为true
 * @param {Boolean} options.broadcast 是否广播模式给其他webview，默认为true
 * @param {Array|String} options.domains 指定能接收到事件的域名，默认只有同域的webview能接收，支持通配符，
 * 比如"*.qq.com"匹配所有qq.com和其子域、"*"匹配所有域名。注意当前webview是否能接收到事件只通过echo来控制，这个domains限制的是非当前webview。
 * @example
 * //1. WebView 1(www.qq.com) 监听 hello 事件
 * mqq.addEventListener("hello", function(data, source){
 *    console.log("someone says hi to WebView 1", data, source)
 * });
 * //2. WebView 2(www.tencent.com) 监听 hello 事件
 * mqq.addEventListener("hello", function(data, source){
 *    console.log("someone says hi to WebView 2", data, source)
 * });
 * //3. WebView 2 抛出 hello 事件
 * //不传配置参数，默认只派发给跟当前 WebView 相同域名的页面, 也就是只有 WebView 2能接收到该事件（WebView 1 接收不到事件，因为这两个 WebView 的域名不同域）
 * mqq.dispatchEvent("hello", {name: "abc", gender: 1});
 *
 * //echo 为 false, 即使 WebView 2 的域名在 domains 里也不会收到事件通知, 该调用的结果是 WebView 1 将接收到该事件
 * mqq.dispatchEvent("hello", {name:"alloy", gender:1}, {
 *     //不把事件抛给自己
 *     echo: false,
 *     //广播事件给其他 WebView
 *     broadcast: true,
 *     //必须是这些域名的 WebView 才能收到事件
 *     domains: ["*.qq.com", "*.tencent.com"]
 * });
 *
 * //echo 和 broadcast 都为 false, 此时不会有 WebView 会接收到事件通知, 但是客户端仍会收到事件, 仍然可以对该事件做处理, 具体逻辑可以每个业务自己处理
 * mqq.dispatchEvent("hello", {name:"alloy", gender:1}, {
 *     echo: false,
 *     broadcast: false,
 *     domains: []
 * });
 *
 * @support iOS 5.0
 * @support android 5.0
 */


function dispatchEvent(eventName, data, options) {
  var params = {
    event: eventName,
    data: data || {},
    options: options || {}
  };
  var url = "jsbridge://event/dispatchEvent?p=".concat(encodeURIComponent(JSON.stringify(params) || ''));
  openURL(url, 'event', 'dispatchEvent');
}
/**
 * @event qbrowserTitleBarClick
 * @desc 点击标题栏事件，监听后点击手机QQ标题栏就会收到通知，可以用来实现点击标题滚动到顶部的功能
 * @param {Function} callback 事件回调
 * @param {Object} callback.data 事件参数
 * @param {Object} callback.data.x 点击位置的屏幕x坐标
 * @param {Object} callback.data.y 点击位置的屏幕y坐标
 * @param {Object} callback.source 事件来源
 * @example
 * mqq.addEventListener("qbrowserTitleBarClick", function(data, source){
 *     console.log("Receive event: qbrowserTitleBarClick, data: " + JSON.stringify(data) + ", source: " +
 * JSON.stringify(source));
 * });
 *
 * @support iOS 5.2
 * @support android 5.2
 */

/**
 * @event qbrowserOptionsButtonClick
 * @desc Android 的物理菜单键的点击事件，点击后会收到通知
 * @param {Function} callback 事件回调
 * @param {Object} callback.data 事件参数
 * @param {Object} callback.source 事件来源
 * @example
 * mqq.addEventListener("qbrowserOptionsButtonClick", function(data, source){
 *     console.log("Receive event: qbrowserOptionsButtonClick, data: " + JSON.stringify(data) + ", source: " +
 * JSON.stringify(source));
 * });
 *
 * @support iOS not support
 * @support android 5.2
 */

/**
 * @event qbrowserPullDown
 * @desc 页面下拉刷新时候会抛出该事件，主要用于与setPullDown交互，具体可参考setPullDown
 * @example
 * mqq.addEventListener("qbrowserPullDown", function () {
 *     // ... Your Code ...
 * });
 * @note 该事件可配合下拉刷新做交互，具体可参考`setPullDown`
 *
 * @support iOS 5.3
 * @support android 5.3
 */

/**
 * @event qbrowserVisibilityChange
 * @desc 当webview可见性发生改变时将会抛出该事件
 * @example
 * mqq.addEventListener("qbrowserVisibilityChange", function(e){
 *     console.log(e.hidden);
 * });
 *
 * @support iOS 4.7
 * @support android 4.7
 */
// ////////////////////////////////// end event /////////////////////////////////////////////////
// for debug


WeishiBridge.__aCallbacks = aCallbacks;
WeishiBridge.__aReports = aReports;
WeishiBridge.__aSupports = aSupports;
WeishiBridge.__aFunctions = aFunctions; // for internal use

WeishiBridge.__fireCallback = fireCallback; // 扩展 WeishiBridge 对象

extend(WeishiBridge, {
  // core
  invoke: invoke,
  callback: createCallbackName,
  execGlobalCallback: execGlobalCallback,
  // event
  on: addEventListener,
  off: removeEventListener,
  dispatchEvent: dispatchEvent,
  execEventCallback: execEventCallback
}, true);
export default WeishiBridge;